import { ActiveOtp, OtpRequest, PastOtp } from '../models/deliveryOtps';
import {
  OtpsDto,
  OtpRequestDto,
  PastOtpsDto,
  OtpTransporterDto,
  LocationTransporterDto,
  PastOtpTransporterDto
} from '../dtos/deliveryOtps';
import { pickupToDto, dropoffToDto } from './locations';
import { LocationDto } from '../models/locations';

export function dtoToOtps({ otps }: OtpsDto): ActiveOtp[] {
  if (!otps) {
    return [];
  }
  // return otps;
  return otps.map(dto => {
    const delivery: ActiveOtp = {
      uuid: dto.uuid,
      expiresAt: new Date(dto.expires_at),
      otp: dto.otp,
      pickupDetails: dto.pickup_details,
      dropoffDetails: dto.dropoff_details
    };

    return delivery;
  });
}

export function pastOtpDtoToPastOtps({ otpbookings }: PastOtpsDto): PastOtp[] {
  if (!otpbookings) {
    return [];
  }
  return otpbookings.map(dto => ({
    otp: dto.otp,
    captainId: dto.captain_id,
    bookingId: dto.booking_id,
    createdAt: new Date(dto.created_at)
  }));
}

export function requestToDto(deliveryRequest: OtpRequest): OtpRequestDto {
  return {
    pickup_details: pickupToDto(deliveryRequest.pickupLocation),
    dropoff_details: dropoffToDto(deliveryRequest.dropOffLocation, deliveryRequest.pickupLocation.city),
    no_of_otps: deliveryRequest.numberOfOtps,
    payment_id: deliveryRequest.defaultPaymentMethodId
  };
}

function transporterLocationDtoToLocationDto(locationTransporter: LocationTransporterDto): LocationDto {
  const {
    locationDetail: { placeName, streetAddress, area, city },
    coordinate: { latitude, longitude },
    saveAs
  } = locationTransporter;
  return {
    coordinate: { lat: latitude, lng: longitude },
    building_name: placeName,
    street: streetAddress,
    nickname: saveAs,
    city,
    area
  };
}

export function dtoToOtpsTransporter(otps: OtpTransporterDto[] = []): ActiveOtp[] {
  if (!otps) {
    return [];
  }
  return otps.map(dto => {
    const { pickup, dropoff, otp, expiresAt, uuid } = dto;
    const pickupDto = pickup && transporterLocationDtoToLocationDto(pickup);
    const dropoffDto = dropoff && transporterLocationDtoToLocationDto(dropoff);
    const delivery: ActiveOtp = {
      uuid: uuid,
      expiresAt: new Date(expiresAt * 1000),
      otp: otp,
      pickupDetails: pickupDto,
      dropoffDetails: dropoffDto
    };

    return delivery;
  });
}

export function pastOtpDtoToPastOtpsTransporter(otpbookings: PastOtpTransporterDto[]): PastOtp[] {
  if (!otpbookings) {
    return [];
  }
  return otpbookings.map(dto => ({
    otp: dto.otp,
    captainId: dto.captainId,
    bookingId: dto.bookingId,
    createdAt: new Date(dto.createdAt * 1000)
  }));
}
